const de = {
  onboarding: {
    countryQuestion: "Verstanden! 🌍\n\nIn welchem Land befindest du dich?",
    countryPlaceholder: "In welchem Land befindest du dich?",
    letsGo: "Los geht's!",
    summaryIntro: "🎉 Toll, {name}! Du bist startklar!",
    yourNameLabel: "dein Name",
    baseLanguageLabel: "Basissprache",
    goalsHint: "Du kannst dein Vokabelziel und die Kursdauer jederzeit auf der Seite Ziele anpassen.",
    startLearning: "Beginne, {destLang} zu lernen!",
  },
  header: {
    learner: "Lernender",
    home: "🏠 Startseite",
    allLessons: "📚 Alle Lektionen",
    currentLesson: "📖 Aktuelle Lektion",
    flashcards: "🃏 Karteikarten",
    progress: "📈 Fortschritt",
    goals: "🎯 Ziele",
    grammarLab: "📘 Grammatik",
    more: "⋯ Mehr",
    myVocabulary: "📝 Mein Wortschatz",
    listenSpeak: "🎧 Hören & Sprechen",
    signOut: "↩ Abmelden",
  },
  lab: {
    title: "Hören-&-Sprechen-Labor",
    back: "Zurück",
    intro: "Führe ein kurzes gesprochenes Gespräch mit Babi über ein Thema, das du bereits gelernt hast.",
    pickTopic: "Wähle ein Thema, das du abgeschlossen hast",
    noTopics: "Schließe zuerst eine Lektion ab und komm dann hierher zurück, um das Sprechen zu üben.",
    level: "Niveau {level}",
    talkAbout: "Sprich mit Babi über „{topic}“",
    speedLabel: "Babis Tempo",
    speedNormal: "Normal",
    speedSlow: "Langsam",
    speedNote: "Langsames Tempo verbraucht mehr deiner Sprachminuten für dieselbe Antwort.",
    startConversation: "Gespräch starten",
    tapToStart: "Tippe auf das Mikrofon und antworte Babi auf Türkisch.",
    continueConversation: "Frage beantworten",
    finishSession: "Beenden",
    voiceReviewHint: "Prüfe, was du gesagt hast, und bestätige es – oder mach es noch mal.",
    voiceConfirm: "Bestätigen",
    voiceRedo: "Wiederholen",
    voiceDenied: "Ohne Mikrofonzugriff ist keine Sprachausgabe möglich. Tippe jederzeit auf das Mikrofonsymbol, um es erneut zu versuchen.",
    lowBalanceWarning: "Deine Sprachminuten für diesen Monatszyklus werden knapp.",
    thinking: "Babi denkt nach…",
    complete: "Sitzung abgeschlossen",
    completeSub: "Gut geübt. Komm jederzeit wieder, um über ein anderes Thema zu sprechen.",
    another: "Ein anderes Thema üben",
    done: "Fertig",
    replyError: "Babi konnte gerade nicht antworten. Bitte versuche es gleich noch einmal.",
    tryAgain: "Erneut versuchen",
    eliteUpsellTitle: "Hören & Sprechen ist eine Elite-Funktion",
    eliteUpsellBody: "Du hast den Pro-Tarif. Wechsle in den Einstellungen zu Elite, um mit Babi das Sprechen zu üben.",
    listenAgainButton: "Nochmal anhören",
    listenAgainPlaying: "Stopp",
    translateButton: "Übersetzen",
    translating: "Übersetzen…",
    translateFailed: "Übersetzung fehlgeschlagen — bitte erneut versuchen.",
    starsAriaLabel: "{stars} von 3",
    explainButton: "Mehr erklären",
    explaining: "Wird erklärt…",
    explainFailed: "Erklärung fehlgeschlagen — bitte erneut versuchen.",
    recapHeading: "Gesprächsbericht",
    recapTitle: "Deine Zusammenfassung",
    recapAvgStars: "Durchschnitt dieser Sitzung",
    recapTurnsCompleted: "{completed} von {total} Runden abgeschlossen",
    recapErrorFree: "{n} fehlerfreie Runden",
    recapMistakesByType: "Fehler nach Art",
    recapCorrections: "Was korrigiert wurde",
    voiceMinutesTitle: "Sprechminuten",
    voiceMinutesLeft: "{amount} von {total} übrig in diesem Zyklus",
    voiceMinutesNone: "Keine Monatsminuten mehr in diesem Zyklus",
  },
  dashboard: {
    greeting: "Hallo, {name}! 👋",
    streakMsg: "{streak}-Tage-Serie 🔥 — weiter so!",
    noStreak: "Starten Sie heute Ihre erste Lektion!",
    streakProtectionDays: "{n} Streak-Schutztage verdient 🛡️",
    dayInfo: "Basissprache: {lang} · Tag {day} von {total}",
    dayStreak: "Tage in Folge",
    share: "Teilen",
    wordsLearned: "Gelernte Wörter",
    lessonsDone: "Abgeschlossene Lektionen",
    goalComplete: "Ziel erreicht",
    timeStudied: "Lernzeit",
    hoursUnit: "Stunden",
    paceTitle: "📊 Täglicher Fortschritts-Tracker",
    statusAhead: "🚀 {delta} Wörter voraus!",
    statusBehind: "⚡ {delta} Wörter aufzuholen",
    statusOnTrack: "✅ Genau im Plan!",
    paceTarget: "Ziel: {wpd} Wörter/Tag · Heute: {today} Wörter",
    paceExpected: "Erwartet: {n}",
    paceGoal: "Ziel: {n}",
    actionCurrentLesson: "Aktuelle Lektion",
    actionAllLessons: "Alle Lektionen",
    actionFlashcards: "Karteikarten",
    actionProgress: "Mein Fortschritt",
    actionGoals: "Meine Ziele",
    actionMyVocabulary: "Mein Wortschatz",
    actionGrammarLab: "Grammatik-Labor",
    actionListenSpeak: "Hören-&-Sprechen-Labor",
    lessonsSub: "{count} Themen · {words} Wörter",
    cardsDue: "{n} Karten fällig!",
    allCaughtUp: "Alles erledigt! 🎉",
    progressSub: "Diagramme, Genauigkeit, Vokabularwachstum",
    myVocabSub: "Alle gelernten Wörter durchsuchen",
    listenSpeakSub: "Übe das Sprechen mit Babi",
    goalsSub: "{words} Wörter · {days} Tage",
    apiCost: "💰 API-Kosten-Tracker",
    since: "seit {date}",
    resetBtn: "↺ Zurücksetzen",
    totalTokens: "Token gesamt",
    inputTokens: "Eingabe",
    outputTokens: "Ausgabe",
    estCost: "Geschätzte Kosten",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Tipp:",
    tips: [
      "Im Türkischen steht das Verb immer am Satzende — «Ben kahve içiyorum» bedeutet «Ich Kaffee trinke.» Nimm einfach die Muster auf!",
      "Das Türkische nutzt Vokalharmonie — Suffixe passen ihre Vokale dem letzten Vokal des Wortstamms an (z. B. -lar/-ler, -da/-de). Sobald man es erkennt, ergibt alles Sinn!",
      "Das Türkische hat kein grammatikalisches Geschlecht. Keine männlichen oder weiblichen Substantive — eine Sache weniger zu merken als im Deutschen, Französischen oder Spanischen!",
      "Personalpronomen (ben = ich, sen = du) werden im Türkischen meist weggelassen, da die Verbendung bereits den Handelnden anzeigt.",
      "Das Türkische ist phonetisch regelmäßig — jeder Buchstabe wird immer gleich ausgesprochen. Was man liest, sagt man genau so aus.",
      "Verneinung wird durch Anhängen von -me/-ma direkt an den Verbstamm gebildet: gel (komm) → gelme (komm nicht), anla (versteh) → anlama.",
      "Das Türkische nutzt Postpositionen, die NACH dem Nomen stehen: «İstanbul'da» = «in Istanbul» (Istanbul + Ortsuffixe -da).",
      "Das Pluralsuffix folgt der Vokalharmonie: -lar nach hinteren Vokalen (a, ı, o, u) und -ler nach vorderen Vokalen (e, i, ö, ü).",
      "Das Suffix -ıyor/-iyor/-uyor/-üyor kennzeichnet das Präsens Progressiv. Anlıyorum = Ich verstehe gerade (anla + ıyor + um).",
      "Türkische Verbalperiphrasen verbinden ein Nomen mit etmek (tun) oder olmak (sein): teşekkür etmek (danken), hazır olmak (bereit sein).",
    ],
  },
  lesson: {
    backBtn: "← Zurück",
    topicOf: "Thema {order} von {total} · {words} Wörter",
    translating: "Lektion wird vorbereitet…",
    newWords: "✨ Neue Wörter ({n})",
    alreadyLearned: "🔄 Bereits gelernt ({n})",
    practiceDialogue: "🎭 Übung",
    generateDialogue: "🎭 Gib mir einen Übungsdialog",
    listenSpeakPractice: "🎧 Im Hören-&-Sprechen-Labor üben",
    generatingDialogue: "Babi bereitet Ihren Dialog vor…",
    newDialogue: "↺ Neuer Dialog",
    lessonSaved: "🎉 Lektion gespeichert! {n} neue Karteikarten werden hinzugefügt…",
    alreadyTaken: "✅ Lektion bereits abgeschlossen",
    markComplete: "✅ Lektion abschließen & Karteikarten speichern",
  },
  vocab: {
    structure: "Struktur",
    loadingExample: "Laden…",
    limitReached: "↺ Limit erreicht",
    anotherLeft: "↺ Noch eine ({n} übrig)",
    anotherExample: "↺ Weiteres Beispiel",
    analyzing: "Analysiere…",
    analyzed: "✓ Analysiert",
    analyzeWord: "🔍 Wort analysieren",
    analysisIntro: "Hier ist die schrittweise grammatikalische Analyse:",
    analysisError: "Analyse konnte nicht geladen werden. Bitte erneut versuchen.",
    reportMistake: "🚩 Fehler melden",
    reportWrongMeaning: "Falsche Wortbedeutung",
    reportWrongSentence: "Falsche Satzbedeutung",
    reportOther: "Sonstiges",
    reportChecking: "Wird überprüft…",
    reportThanks: "✓ Danke, dass du uns hilfst, uns zu verbessern!",
    reportNoIssue: [
      "Ich konnte hier kein Problem finden — das sieht für mich richtig aus!",
      "Ich sehe hier keine Probleme — das sieht richtig aus.",
      "Aus meiner Sicht scheint alles in Ordnung zu sein.",
      "Ich konnte keine Probleme feststellen; das scheint so geschrieben richtig zu sein.",
      "Das sieht für mich gut aus — ich habe keine Bedenken.",
      "Ich habe es überprüft und nichts gefunden, das geändert werden müsste.",
      "Mir ist nichts aufgefallen; die Übersetzung sieht richtig aus.",
      "Soweit ich das beurteilen kann, ist alles korrekt.",
      "Ich konnte keine Probleme entdecken; das sieht für mich gut aus.",
    ],
    reportCheckError: "Bei der Überprüfung ist ein Problem aufgetreten. Bitte versuche es später erneut.",
    reportOkBtn: "OK, verstanden",
    reportEscalateBtn: "An einen menschlichen Prüfer weiterleiten",
    reportEscalatedMsg: "✓ An unser Prüfteam gesendet. Danke!",
    reportAlreadyFlaggedMsg: "✓ Dies wurde bereits an unser Prüfteam gemeldet. Danke!",
  },
  allLessons: {
    title: "📚 Alle Lektionen",
    subtitle: "{count} Themen · {words} Wörter",
    searchPlaceholder: "🔍 Themen oder Wörter suchen…",
    noResults: "Keine Themen passen zu \"{search}\"",
    overwhelmedBanner: "Du hast {n} Karten zu wiederholen. Bitte überarbeite deine Lernkarten, bevor du neue Lektionen beginnst.",
    overwhelmedLock: "Zuerst Lernkarten wiederholen",
    overwhelmedBtn: "Zu den Karteikarten →",
  },
  flashcards: {
    title: "Karteikarten",
    cardOf: "Karte {current} von {total}",
    tapToReveal: "Tippen zum Aufdecken",
    hearIt: "🔊 Anhören",
    hearSentence: "🔊 Den Satz anhören.",
    allConsolidated: "Alles konsolidiert",
    noDue: "Keine Karten sind jetzt fällig.\nIhr Gedächtnis ist gut ausgeruht.",
    backToDashboard: "Zurück zum Dashboard",
    sessionComplete: "Sitzung abgeschlossen",
    memoryRetention: "Gedächtniseffizienz",
    forgotten: "Vergessen",
    struggled: "Schwierig",
    recalled: "Erinnert",
    effortless: "Mühelos",
    wordsConsolidated: "{retained} von {total} Wörtern konsolidiert",
    wordsInProgress: "{retained} von {total} Wörtern in Bearbeitung",
    saveContinue: "Speichern & Weiter",
    tomorrow: "Morgen",
    nDays: "{n} Tage",
    d1Title: "Verständnis",
    d1SubSkill: "Zum Verbessern von Lese- und Hörfähigkeiten",
    d1Journey: "Neue Wörter beginnen ihre Reise hier.",
    d1Due: "{n} fällig",
    d1Listen: "Anhören",
    d1ShowWord: "Wort anzeigen",
    d2Title: "Produktion",
    d2SubSkill: "Zum Verbessern von Sprech- und Schreibfähigkeiten",
    d2WillStart: "Startet später",
    d2Empty: "Wörter kommen hierher, sobald sie im Verständnis-Kartenset gut beherrscht werden.",
    d2ModalTitle: "Produktionsübung freigeschaltet!",
    d2ModalBody: "Das sind Wörter, die du bereits gut erkennst. Jetzt trainieren wir dich, sie zu produzieren — so gelangst du vom Verstehen des {targetLang} zum Sprechen.",
    d2ModalBtn: "Verstanden",
    leaveConfirmTitle: "Nicht gespeicherter Wiederholungsfortschritt",
    leaveConfirmBody: "Du hast in dieser Sitzung Karten wiederholt, die noch nicht gespeichert wurden. Wenn du jetzt ohne zu speichern verlässt, geht dieser Fortschritt verloren.",
    leaveConfirmSave: "Speichern und verlassen",
    leaveConfirmDiscard: "Verwerfen und verlassen",
    leaveConfirmCancel: "Abbrechen",
    faq: {
      whyTwoQ: "Warum zwei Decks?",
      whyLaterQ: "Warum startet das Produktions-Kartenset später?",
      whyReturnQ: "Warum kommen Karten immer wieder?",
    },
  },
  grammarLab: {
    title: "📘 Grammatik-Labor",
    subtitle: "{count} Grammatikthemen zum Entdecken",
    backBtn: "← Zurück",
    searchPlaceholder: "🔍 Grammatikthemen suchen…",
    noResults: "Keine Grammatikthemen gefunden für \"{search}\"",
    allCategories: "Alle Kategorien",
    allLevels: "Alle Stufen",
    notReviewedLabel: "Nicht angesehen",
    reviewedLabel: "Angesehen",
    dueBadge: "{n} fällig",
    explanationLabel: "Erklärung",
    seeReference: "(siehe {term})",
    ruleLabel: "Regel",
    formsLabel: "Formen",
    translatingNote: "Wird gerade ins Deutsche übersetzt…",
    practiceBtn: "▶ Dieses Thema üben",
    detailedExplanationBtn: "📖 Ausführliche Erklärung",
    practiceTitle: "Übung",
    practiceQuestion: "Wie sagt man das auf Türkisch?",
    practiceOf: "{current} von {total}",
    practiceCorrectFeedback: "Richtig!",
    practiceIncorrectFeedback: "Nicht ganz — die richtige Antwort war {answer}.",
    practiceNext: "Weiter →",
    practiceDone: "Übung abgeschlossen",
    practiceScore: "{correct} von {total} richtig",
    practiceNextReview: "Nächste Wiederholung in {days} Tag(en)",
    practiceReset: "Diesmal nicht — du siehst dieses Thema morgen wieder.",
    practiceAgainBtn: "Erneut üben",
    practiceCloseBtn: "Fertig",
    categories: {
      existential: "Existenz",
      noun_suffix: "Nomen-Suffix",
      case_suffix: "Kasus-Suffix",
      verb_conjugation: "Verbkonjugation",
      question_particle: "Fragepartikel",
      copula: "Kopula",
      modal_construction: "Modalkonstruktion",
      adjectives: "Adjektive",
      case: "Kasus",
      modality: "Modalität",
      mood: "Modus",
      morphology: "Morphologie",
      morphophonology: "Morphophonologie",
      phonology: "Phonologie",
      pronouns: "Pronomen",
      register: "Register",
      syntax: "Syntax",
      tense: "Tempus",
      voice: "Genus Verbi",
    },
    points: {
      GP0001: { title: "Existenz und Verfügbarkeit: var / yok", ruleSummary: "[Ort/Besitzer] + [Sache] + var / yok" },
      GP0002: { title: "Pluralsuffix: -ler / -lar", ruleSummary: "Nomen + -ler (hell) / -lar (dunkel)" },
      GP0003: { title: "Lokativ: -de / -da / -te / -ta", ruleSummary: "Nomen + -de/-da; -te/-ta nach stimmlosem Konsonant" },
      GP0004: { title: "Dativ: -e / -a", ruleSummary: "Nomen + -e/-a; nach Vokal wird ein Puffer-y eingefügt" },
      GP0005: { title: "Ablativ: -den / -dan / -ten / -tan", ruleSummary: "Nomen + -den/-dan; -ten/-tan nach stimmlosem Konsonant" },
      GP0006: { title: "Akkusativ: -i / -ı / -u / -ü (bestimmtes direktes Objekt)", ruleSummary: "Nomen + -i/-ı/-u/-ü; Puffer-y nach Vokal" },
      GP0007: { title: "Präsens Progressiv — Bejaht: -iyor", ruleSummary: "Verbstamm + -iyor + Personalendung" },
      GP0008: { title: "Präsens Progressiv — Verneint: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "Verbstamm + -mıyor/-miyor/-muyor/-müyor + Personalendung" },
      GP0009: { title: "Präsens Progressiv — Frage: -iyor mu", ruleSummary: "Stamm + -iyor + mu(+Personalendung); onlar: Stamm + -iyorlar + mı" },
      GP0010: { title: "Ja/Nein-Fragepartikel: mı / mi / mu / mü", ruleSummary: "[Wort] + getrennt geschriebene Partikel mı/mi/mu/mü ?" },
      GP0011: { title: "Bestimmte Vergangenheit: -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "Verbstamm + -di/-dı/-du/-dü (bzw. -ti/... nach stimmlosem Konsonant) + Personalendung" },
      GP0012: { title: "Prädikative 'Sein'-Endungen (Präsens): -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "Prädikat + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Possessivsuffixe: mein / dein / sein-ihr / unser / euer / ihr", ruleSummary: "(benim/senin/...) Nomen + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Wunsch ausdrücken: -mek / -mak istemek", ruleSummary: "[Infinitiv -mek/-mak] + istemek (konjugiert)" },
      GP0015: { title: "Höfliche Bitte / Imperativ 2. Person Plural: -in / -iniz", ruleSummary: "Verbstamm + -in/-ın/-un/-ün (höflich) oder -iniz (förmlicher); Puffer-y nach Vokal" },
      GP0016: { title: "Konsonantenerweichung (Entstimmlichung): p/ç/t/k → b/c/d/ğ", ruleSummary: "[Wort endet auf p/ç/t/k, falls lexikalisch erweichend] + vokalisch anlautendes Suffix → b/c/d/ğ ersetzt den letzten Konsonanten" },
      GP0017: { title: "Unregelmäßige Verbstämme: gitmek, etmek, yemek, demek", ruleSummary: "git-→gid-, et-→ed-, ye-→yi-, de-→di- vor einem vokalisch anlautenden Suffix" },
      GP0018: { title: "Vokalausfall-Stämme vor -iyor", ruleSummary: "[Verbstamm endet auf unbetontes -e/-a] + -iyor → der letzte Vokal fällt aus, dann wird -iyor angehängt" },
      GP0019: { title: "Türkische Vokale", ruleSummary: "8 Vokale: a, e, ı, i, o, ö, u, ü — jeder ist vorne/hinten UND ungerundet/gerundet" },
      GP0020: { title: "Vokalharmonie", ruleSummary: "Der Suffixvokal richtet sich nach dem letzten Vokal des Wortes: heller Stamm → heller Suffixvokal, dunkler Stamm → dunkler Suffixvokal (und gerundet/ungerundet bei 4-fachen Suffixen)" },
      GP0021: { title: "Genitiv: -in/-ın/-un/-ün", ruleSummary: "[Nomen] + in/ın/un/ün (4-fache Harmonie; Puffer -n- wenn das Nomen auf einen Vokal endet)" },
      GP0022: { title: "Possessivdeterminative (benim, senin, onun...)", ruleSummary: "Personalpronomen + Genitivsuffix: ben→benim, sen→senin, o→onun, biz→bizim, siz→sizin, onlar→onların" },
      GP0023: { title: "Futur: -ecek/-acak", ruleSummary: "[Stamm] + (y) + ecek/acak (k→ğ vor vokalisch anlautender Personalendung) + Person" },
      GP0024: { title: "Berichtete Vergangenheit (Evidential): -miş", ruleSummary: "[Stamm] + mış/miş/muş/müş (4-fache Harmonie) + prädikative Personalendung" },
      GP0025: { title: "Präteritum Progressiv: -iyordu", ruleSummary: "[Stamm in -iyor-Form] + du/dun/duk/dunuz (+ -lar wird vor -dı für 3. Pl. angehängt)" },
      GP0026: { title: "Fähigkeit: -ebilmek/-abilmek ('können') - bejaht", ruleSummary: "[Stamm] + (y)e/(y)a + bil + ir (immer -ir, aufgrund der eigenen festen Aorist-Ausnahme von bilmek) + Person" },
      GP0027: { title: "Wortstellung", ruleSummary: "Standard: Subjekt - Objekt/Ort - Verb (Verb steht am Ende). Flexibel zur Betonung; die Rolle wird durch Kasussuffixe markiert, nicht durch die Position." },
      GP0028: { title: "Konjunktionen", ruleSummary: "ve (und), ama (aber), çünkü (weil), veya (oder) - unveränderliche Wörter, keine Suffixkonjugation" },
      GP0029: { title: "Postpositionen (Präpositionen)", ruleSummary: "ile (mit), için (für), gibi (wie/als), kadar (bis/so viel wie), önce (vor), sonra (nach) - stehen alle nach dem Nomen" },
      GP0030: { title: "Komparativ und Superlativ", ruleSummary: "daha + Adjektiv (Komparativ); en + Adjektiv (Superlativ); [Nomen-Ablativ] daha [Adjektiv] = 'ADJ-er als Nomen'" },
      GP0031: { title: "Türkische Adverbien (Häufigkeit/Grad)", ruleSummary: "çok (sehr/viel), az (ein wenig), hiç (nie/überhaupt nicht - mit verneintem Verb verwendet), bazen (manchmal), şimdi (jetzt)" },
      GP0032: { title: "Aorist (Einfaches Präsens / Habituell): -er/-ir/-ar/-ır", ruleSummary: "Mehrsilbig: [Stamm]+ir/ır/ur/ür (konsonantisch endend, regelmäßig) oder [Stamm]+r (vokalisch endend, regelmäßig). Einsilbig konsonantisch endend: LEXIKALISCH GETEILT zwischen -Ar und -Ir - pro Verb prüfen, nicht raten." },
      GP0033: { title: "Präteritum Habituell: -erdi/-ırdı ('pflegte zu')", ruleSummary: "[Aorist-Stamm] + di/dı/du/dü (4-fach, nach dem eigenen Vokal von -ir/-ar) + Person" },
      GP0034: { title: "Futur in der Vergangenheit: -ecekti/-acaktı", ruleSummary: "[Futur-Stamm] + ti (stimmlos, Singular/1. Pl.) ODER + ler + di (stimmhaft, 3. Pl., keine Entstimmlichung, da -ler auf 'r' endet)" },
      GP0035: { title: "Irrealer Konditional: -se/-sa (nackter Stamm)", ruleSummary: "[Stamm] + se/sa (2-fach) + Person (m, n, -, k, niz, ler)" },
      GP0036: { title: "Notwendigkeit: -malı/-meli ('müssen / sollen')", ruleSummary: "[Stamm] + malı/meli (2-fach) + (y) + prädikative Personalendung" },
      GP0037: { title: "Subjektpartizip: -en/-an ('derjenige, der...')", ruleSummary: "[Stamm] + en/an (2-fach); vokalisch endende Stämme erhalten Puffer -y-" },
      GP0038: { title: "Temporalsatz: -ince/-ınca ('wenn...')", ruleSummary: "[konsonantisch endender Stamm] + ince/ınca (2-fach, bestätigtes Muster); Muster für vokalisch endende Stämme NOCH NICHT BESTÄTIGT" },
      GP0039: { title: "Vergleich der Vergangenheitsformen", ruleSummary: "-di (miterlebt) vs. -miş (berichtet) vs. -iyordu (war gerade dabei) vs. -irdi (pflegte zu tun)" },
      GP0040: { title: "Kasusformen der Demonstrativpronomen: bu/şu/o", ruleSummary: "bu/şu/o + n (Puffer) + Kasussuffix" },
      GP0041: { title: "Ortsdemonstrativa: bura/şura/ora ('hier/dort')", ruleSummary: "bura/şura/ora + Kasussuffix (Puffer -y- nur vor dem Dativ)" },
      GP0042: { title: "Fragewörter", ruleSummary: "ne, kim, nerede, nasıl, kaç, ne zaman, neden - alle unveränderlich" },
      GP0043: { title: "Instrumental: -(y)le/-(y)la ('mit / mittels')", ruleSummary: "[Nomen] + (y)le/(y)la (2-fache Harmonie; Puffer -y- wenn vokalisch endend)" },
      GP0044: { title: "'Mit/Ohne'-Adjektivsuffixe: -lı/-siz", ruleSummary: "[Nomen] + lı/li/lu/lü ('mit') oder sız/siz/suz/süz ('ohne') - 4-fache Harmonie" },
      GP0045: { title: "Unfähigkeit: -(y)AmA- ('nicht können')", ruleSummary: "[Stamm] + (y)e/(y)a + me/ma + verneinte Aorist-Personalendung (m/mez-sin/mez/meyiz/mez-siniz/mez-ler)" },
      GP0046: { title: "Realer Konditional: [Aorist-Stamm] + -se/-sa ('falls X geschieht')", ruleSummary: "[Aorist-Stamm] + se/sa (2-fach, nach dem eigenen Vokal des Aorist-Suffixes) + Person" },
      GP0047: { title: "Objektpartizip: -DIk + Possessiv ('dass [Subjekt] verbte')", ruleSummary: "[Stamm] + DIk (4-fach; erweicht zu ğ nur vor vokalisch anlautendem Possessiv) + Possessiv" },
      GP0048: { title: "Verwendung des Futurpartizips (nutzt die Formen des Futurs)", ruleSummary: "Dieselben Oberflächenformen wie das Futur (see GP0023), adjektivisch vor einem Nomen verwendet statt als finites Verb" },
      GP0049: { title: "Temporalsätze: -DIğI zaman / -mADIğI zaman / -DIktan sonra", ruleSummary: "[Objektpartizip] + zaman = 'wenn'; [nacktes -DIk] + ten + sonra = 'nachdem'" },
      GP0050: { title: "Das Suffix -ki (Relativierer)", ruleSummary: "[lokatives Nomen / genitivisches Pronomen] + ki (UNVERÄNDERLICH - keine Harmonie)" },
      GP0051: { title: "Dauer: -DAn beri / -DIr ('seit / seit X andauernd')", ruleSummary: "[Zeit]+den beri = 'seit X'; [Dauer]+dir/dır/dur/dür + Präsens = 'seit X (und andauernd)'" },
      GP0052: { title: "Passiv: -Il/-In", ruleSummary: "konsonantisch endend (nicht l): +Il/ıl/ul/ül; auf l endend: +In/ın/un/ün; vokalisch endend: +n" },
      GP0053: { title: "Kausativ: -t/-DIr/-Ir (nur kuratierte Liste - lexikalisch komplex)", ruleSummary: "Lexikalisch bestimmtes Allomorph - jedes Verb einzeln prüfen, nicht verallgemeinern" },
      GP0054: { title: "Reflexiv: -In/-ın ('X an sich selbst tun')", ruleSummary: "[Stamm] + In/ın/un/ün (oder n nach Vokal) - reflexive Bedeutung, lexikalisch bestimmt wie das Passiv (see GP0052)" },
      GP0055: { title: "Reziprok: -Iş/-ış ('X einander antun')", ruleSummary: "[Stamm] + Iş/ış/uş/üş (4-fach) - gegenseitige/gemeinsame Handlung" },
      GP0056: { title: "Optativ (Lass mich / Lass uns): -(y)eyim/-(y)elim", ruleSummary: "[Stamm] + (y)eyim (1. Sg.) / (y)elim (1. Pl.) - 2-fache Harmonie" },
      GP0057: { title: "Erzählregister: Wiederholtes -mış (Erzählstil)", ruleSummary: "-mış wird im Verlauf einer Erzählung wiederholt verwendet, nicht nur einmal, um das Erzählregister aufrechtzuerhalten" },
      GP0058: { title: "'Ne kadar da' (Verstärker - 'wie sehr...!')", ruleSummary: "Ne kadar da + [Adjektiv] = ausrufender Verstärker" },
      GP0059: { title: "Modalkonverb: -ArAk ('indem/während man X tut')", ruleSummary: "[Stamm] + arak/erek (2-fache Harmonie)" },
      GP0060: { title: "Sequenzielles Konverb: -Ip ('und, nachdem man X getan hat')", ruleSummary: "[Stamm] + Ip/ıp/up/üp (4-fach) - nur das letzte Verb der Kette trägt ein Tempus" },
      GP0061: { title: "Kausalsatz: -DIğI için ('weil X [geschah]')", ruleSummary: "[Objektpartizip] (see GP0047) + için (see GP0029) = 'weil X'" },
      GP0062: { title: "'Diye' ('in der Annahme/mit den Worten, dass...')", ruleSummary: "[Nebensatz] + diye + [Hauptsatz] = 'in der Annahme/aus dem Grund, dass [Nebensatz], [Hauptsatz]'" },
      GP0063: { title: "'Olarak' ('als X / in der Eigenschaft als X')", ruleSummary: "[Nomen] + olarak = 'als [Nomen]'" },
      GP0064: { title: "'Tarafından' (Passiv-Agens-Marker - 'von X')", ruleSummary: "[Nominalphrase] + tarafından + [Passivverb] (see GP0052)" },
      GP0065: { title: "'Rağmen' ('trotz')", ruleSummary: "[Nomen + Dativ] (see GP0004) + rağmen = 'trotz X'" },
      GP0066: { title: "'Göre' ('laut / gemäß')", ruleSummary: "[Nomen/Pronomen + Dativ] + göre = 'laut X'" },
      GP0067: { title: "Semi-Modalverben + Dativergänzung", ruleSummary: "[Nomen/Verb-mA] + Dativ + alışmak/başlamak/çalışmak/karar vermek/izin vermek/benzemek/inanmak/üzülmek" },
      GP0068: { title: "Epistemische und Evidentielle Ausdrücke", ruleSummary: "gibi geliyor = 'es scheint' (see GP0029) (see GP0007); -mış olmalı = 'muss ... haben' (see GP0024) (see GP0036); -mış görünmek = 'scheint ... zu haben'; bildiğim kadarıyla = 'soweit ich weiß' (see GP0047) (see GP0029) (see GP0043)" },
      GP0069: { title: "Häufige Verben + Akkusativobjekt: unutmak, sormak, hatırlamak", ruleSummary: "[Nomen + Akkusativ] (see GP0006) + unutmak/sormak/hatırlamak" },
      GP0070: { title: "Konuşmak vs. Söylemek ('sprechen' vs. 'sagen/erzählen')", ruleSummary: "konuşmak = der Akt des Sprechens (Sprache/Person); söylemek = [eine bestimmte Sache] sagen/erzählen, Akkusativobjekt" },
    },
  },
  placementTest: {
    title: "🎯 Einstufungstest",
    offerTitle: "Kannst du schon etwas Türkisch?",
    offerBody: "Mach einen kurzen Einstufungstest — etwa 20 Fragen — um dein Startniveau zu finden. Wir passen deine aktuelle Lektion entsprechend an, aber alle Themen bleiben zum Durchstöbern offen.",
    startBtn: "Test starten",
    notNowBtn: "Jetzt nicht",
    roundLabel: "Runde {round} von {totalRounds}",
    questionLabel: "Frage {n} von {total}",
    notSureOption: "Ich bin mir nicht sicher",
    notSureHint: "(Wähle die fünfte Option, wenn du dir nicht 100 % sicher bist.)",
    wordPrompt: "Was bedeutet dieses Wort?",
    listeningPrompt: "Hör zu und wähle das Wort, das du hörst",
    listeningReplay: "Erneut abspielen",
    preparingRound: "Deine Fragen werden vorbereitet…",
    finishBtn: "Mein Ergebnis ansehen",
    resultsTitle: "Dein Einstufungsergebnis",
    resultsLevel: "Du wurdest auf {level} eingestuft",
    resultsBody: "Deine aktuelle Lektion beginnt jetzt auf diesem Niveau. Du kannst jederzeit frühere oder spätere Themen in Alle Lektionen durchstöbern.",
    continueBtn: "Weiter",
  },
  goals: {
    title: "🎯 Meine Ziele",
    displayName: "Anzeigename",
    namePlaceholder: "Ihr Name…",
    vocabTarget: "Vokabularziel",
    words: "Wörter",
    minWords: "1.500 min",
    midWords: "2.000",
    maxWords: "3.500 max",
    courseDuration: "Angestrebte Kursdauer",
    months: "Monate",
    month: "Monat",
    monthsPlural: "Monate",
    daysSummary: "= {days} Tage",
    baseLanguage: "Basissprache",
    otherLanguage: "Weitere Sprachen (bald verfügbar)",
    selectLanguage: "Sprache auswählen…",
    ok: "OK",
    langNames: {
      English: "Englisch", Farsi: "Persisch", Arabic: "Arabisch",
      French: "Französisch", German: "Deutsch", Spanish: "Spanisch",
      Russian: "Russisch", Portuguese: "Portugiesisch", Chinese: "Chinesisch",
      Turkish: "Türkisch", Hindi: "Hindi", Italian: "Italienisch",
    },
    targetLanguage: "Zielsprache",
    targetLangNames: {
      Turkish: "Türkisch",
    },
    wordsLbl: "Wörter",
    wordsPerDay: "Wörter/Tag",
    daysLbl: "Tage",
    saved: "✅ Ziele gespeichert!",
  },
  progress: {
    title: "📈 Mein Fortschritt",
    memDistTitle: "Gedächtniszustandsverteilung · {n} Karten",
    inAcquisition: "In Aneignung",
    rooted: "Verwurzelt",
    fluent: "Fließend",
    deeplyRetained: "Tief verankert",
    acqDesc: "< 3T Stabilität",
    rootedDesc: "3–21T Stabilität",
    fluentDesc: "21–90T Stabilität",
    retainedDesc: "90T+ Stabilität",
    forecastTitle: "Wiederholungsvorschau — nächste 15 Tage",
    cardsDue: "Fällige Karten",
    today: "Heute",
    tmrw: "Morg.",
    plusDays: "+{n}T",
    todayFull: "Heute",
    tmrwFull: "Morgen",
    plusDaysFull: "+{n} Tage",
    goalProgress: "Gesamter Zielfortschritt",
    wordsLearned: "{learned} / {target} Wörter gelernt",
    vocabGrowth: "Vokabularwachstum",
    noChart: "Schließen Sie Ihre erste Lektion ab, um das Diagramm zu sehen! 📚",
    wordsLearnedSeries: "Gelernte Wörter",
    topicRings: "Themengedächtnisringe",
    quickStats: "Schnellstatistiken",
    dayStreak: "Tage in Folge 🔥",
    lessonsDone: "Lektionen abgeschlossen",
    totalStudy: "Gesamte Lernzeit",
    avg14Day: "14-Tage-Durchschnitt",
    minUnit: "Min",
    dayLabel: "Tag {n}",
    cards: "Karten",
  },
  myVocab: {
    title: "📝 Mein Wortschatz",
    summaryTitle: "{n} gelernte Wörter",
    searchPlaceholder: "🔍 Deine Wörter durchsuchen…",
    allStatuses: "Alle Status",
    noResults: "Keine Wörter entsprechen \"{search}\"",
    noWords: "Schließe eine Lektion ab, um deinen Wortschatz aufzubauen! 📚",
    completedTopicsTitle: "Abgeschlossene Themen ({n} von {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Neuling",
    wordExplorer: "Wortentdecker",
    wordNerd: "Wort-Nerd",
    wordWizard: "Wortzauberer",
    rockstar: "Rockstar",
    expert: "Experte",
    champion: "Champion",
  },
  memStates: {
    inAcquisition: "In Aneignung",
    rooted: "Verwurzelt",
    fluent: "Fließend",
    deeplyRetained: "Tief verankert",
  },
  chat: {
    subtitle: "Ihr Türkisch-Tutor",
    greetWords: ["Hi", "Hallo", "Servus"],
    greeting: "{greet} {name},\n\nFragen Sie mich alles über Türkisch — Grammatik, Vokabular, Kultur — oder über die Nutzung dieser App.",
    placeholder: "Fragen über Türkisch oder die App…",
    error: "Entschuldigung, ich konnte keine Verbindung herstellen. Bitte versuchen Sie es erneut.",
    escalationFallback: "Es tut mir leid, dass ich dabei nicht vollständig helfen konnte. Ich habe das an unser Team weitergeleitet, und Sie erhalten eine Antwort per E-Mail — in der Regel innerhalb von 2 Werktagen. Sie können uns auch direkt unter support@speafy.com erreichen.",
    welcome: "Hallo, {name}! 👋 Willkommen bei Speafy! Ich bin Babi und bin für zwei Dinge da: Ihnen zu helfen, sich in der App zurechtzufinden, und alle Fragen zu {targetLanguage} zu beantworten.\n\nBeginnen Sie mit der aktuellen Lektion oder wählen Sie ein Thema aus «Alle Lektionen». Vergessen Sie nicht, jede Lektion als abgeschlossen zu markieren, wenn Sie fertig sind, und danach die Karteikarten zu wiederholen.\n\nFragen Sie mich jederzeit — zur App oder zu {targetLanguage}.\n\nViel Erfolg auf Ihrer Lernreise! 😊",
    lessonLimit: "Du hast heute bereits {limit} Lektionen abgeschlossen — fantastisch! 🌟\n\nUm dein Lernen nachhaltig zu halten und deine Karteikarten-Warteschlange nicht zu überlasten, gibt es ein Tageslimit von {limit} Lektionen.\n\nGib deinem Gehirn etwas Zeit, das Gelernte zu festigen. Wie wäre es stattdessen mit einer Wiederholung der Karteikarten?\n\nBis morgen für mehr! 😊",
    streakDecayed: "Willkommen zurück! 👋 Du warst {days} Tag(e) weg. Dank der {protection} Streak-Schutztage 🛡️, die du dir verdient hast, ist deine Serie nur von {oldStreak} auf {newStreak} gesunken, statt komplett zu verschwinden. Lass uns weiter aufbauen!",
    streakWiped: "Willkommen zurück! 👋 Du warst {days} Tag(e) weg — mehr als die {protection} Streak-Schutztage 🛡️, die du gesammelt hattest, also ist deine Serie wieder bei 1 gestartet. Jede Serie fängt irgendwo an — lass sie uns neu aufbauen!",
    weeklyRecapFallback: "Hey! 👋 Ich wollte dir deine Wochenzusammenfassung bringen, habe aber gerade Schwierigkeiten, sie zusammenzustellen. Trotzdem kurz gesagt — du hast eine Serie von {streak} Tag(en), mach weiter so! 🔥",
    dailyPlanQuestion1: "Hey! 👋 Wie viel Zeit hast du heute zum Lernen?",
    dailyPlanQuestion2: "Hi! 😊 Ich habe einen Lernplan für dich — wie viele Minuten kannst du heute erübrigen?",
    dailyPlanQuestion3: "Bereit für den heutigen Plan? 🎯 Sag mir einfach ungefähr, wie viel Zeit du hast.",
    dailyPlanClarify: "Sorry, das habe ich nicht ganz verstanden! Kannst du mir eine ungefähre Zahl nennen, wie '20' oder '30 Minuten'?",
    dailyPlanUnreasonable: "Das klingt nicht nach einer typischen Lerneinheit! Kannst du mir etwas zwischen 5 Minuten und etwa 5 Stunden nennen?",
    dailyPlanGiveUp: "Kein Problem — wenn du bereit bist, geh einfach zu den Karteikarten oder deiner aktuellen Lektion und leg los! 😊",
    dailyPlanFallback: "Ich habe deine verfügbare Zeit notiert, habe aber gerade Schwierigkeiten, den heutigen Plan zu erstellen. In der Zwischenzeit sind Karteikarten immer eine gute Wahl, wenn fällige Karten warten! 😊",
    sendBtn: "Senden",
    askBabi: "Babi fragen",
    voiceConsentTitle: "Sprachchat mit Babi aktivieren?",
    voiceConsentBody: "Babi nutzt dein Mikrofon, um dich zu hören, und deinen Lautsprecher, um dir zu antworten. Deine Sprache wird in Text umgewandelt — die Audioaufnahme selbst wird nie gespeichert. Der Text kann bis zu 30 Tage aufbewahrt werden. Details findest du in unserer Datenschutzerklärung.",
    voiceConsentPrivacyLink: "Datenschutzerklärung",
    voiceConsentAllow: "Mikrofon erlauben",
    voiceConsentDecline: "Nicht jetzt",
    voiceDenied: "Sprachchat ist ohne Mikrofonzugriff nicht verfügbar. Du kannst weiterhin per Text chatten — tippe jederzeit auf das Mikrofonsymbol, um es erneut zu versuchen.",
    voiceDeviceInUse: "Dein Mikrofon scheint anderweitig verwendet zu werden — schließe andere Apps, die es nutzen, und versuche es erneut.",
    voiceError: "Beim Sprachchat ist etwas schiefgelaufen. Bitte versuche es erneut.",
    voiceStarting: "Wird gestartet… bitte warten",
    voiceListening: "Ich höre zu…",
    voiceProcessing: "Verstehe…",
    voiceReviewHint: "Zum Bearbeiten tippen, sonst wird dies in wenigen Sekunden automatisch gesendet.",
    voiceSendNow: "Jetzt senden",
    voiceDiscard: "Verwerfen",
    voiceEditTranscript: "Bearbeite, was Babi gehört hat",
    voiceBadgeLabel: "Per Sprache gesendet",
    voiceDidntCatch: "Das habe ich nicht verstanden — tippe auf das Mikrofon, um es erneut zu versuchen.",
    voiceSpeaking: "Babi spricht…",
    voiceTtsUnavailable: "Für diese Antwort war kein Audio verfügbar — stattdessen wird der Text angezeigt.",
    voiceTtsUnavailableLanguage: "Babis gesprochene Antwort ist auf {language} noch nicht verfügbar.",
    voiceTapToHear: "Tippen, um Babis Antwort zu hören",
    voiceNotEntitled: "Sprachchat mit Babi ist eine Premium-Funktion — upgrade, um sie zu nutzen.",
    voiceNoBalance: "Du hast alle Sprachminuten für diesen Zyklus aufgebraucht. Sie werden im nächsten Zyklus erneuert.",
    voiceOtherTabActive: "Sprachchat ist bereits in einem anderen Tab aktiv.",
    voiceLowBalanceNudge: "Dir gehen die Sprachminuten für diesen Zyklus langsam aus.",
    voiceLowMinutesHeadsUp: "Dir gehen die Sprachminuten für diesen Zyklus langsam aus.",
    voiceGetMoreMinutes: "Weitere Minuten holen",
    voiceStopBtn: "Stopp",
    voiceMicButtonLabel: "Sprachchat",
    voiceBannerDismiss: "Schließen",
  },
  settings: {
    title: "Einstellungen",
    accountSection: "Konto",
    linkedGoogle: "Mit Google verknüpft",
    emailAccountBadge: "E-Mail-Konto",
    changeNameBtn: "Benutzernamen ändern",
    nameSaveBtn: "Speichern",
    nameCancelBtn: "Abbrechen",
    nameSaving: "Speichern…",
    passwordLabel: "Passwort",
    passwordSub: "Einen Reset-Link an deine E-Mail senden",
    passwordSent: "Gesendet ✓",
    passwordResetBtn: "Zurücksetzen",
    subscriptionSection: "Abonnement",
    subscriptionAdminLabel: "Administrator-Konto",
    subscriptionAdminSub: "Du hast vollen, dauerhaften Zugriff auf alle Funktionen.",
    subscriptionReviewerLabel: "Tester-Zugang",
    subscriptionReviewerSub: "Du hast als App-Tester kostenlosen Zugriff auf alle Funktionen.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Jährlich",
    subscriptionPlanMonthly: "Monatlich",
    subscriptionRenews: "Verlängert sich am {date}",
    subscriptionActive: "Aktiv",
    subscriptionManageLink: "Abrechnung & Rechnungen",
    subscriptionCancelLink: "Abo kündigen oder pausieren",
    subscriptionPaymentFailedLabel: "Deine letzte Zahlung ist fehlgeschlagen",
    subscriptionPaymentFailedSub: "Zahlung fehlgeschlagen am {date}",
    subscriptionPaymentFailedSubNoDate: "Bitte aktualisiere deine Zahlungsmethode, um deinen Pro-Zugang zu behalten",
    subscriptionUpdatePaymentLink: "Zahlungsmethode aktualisieren ↗",
    subscriptionCancelledPending: "Dein Plan endet am {date} — bis dahin behältst du den Pro-Zugang",
    subscriptionPausedLabel: "Abo pausiert",
    subscriptionPausedSub: "Wird am {date} automatisch fortgesetzt — du wirst dann in voller Höhe für einen neuen Zeitraum belastet, es sei denn, du setzt vorher fort",
    subscriptionPausedSubNoDate: "Wird nach 3 Monaten automatisch fortgesetzt, es sei denn, du setzt vorher fort",
    subscriptionResumeBtn: "Jetzt fortsetzen",
    subscriptionResuming: "Wird fortgesetzt…",
    pausePendingLabel: "Pause geplant",
    pausePendingSub: "Tritt am {date} in Kraft, am Ende deines aktuellen Abrechnungszeitraums",
    manageOfferTitle: "Denkst du über eine Kündigung nach?",
    manageOfferSub: "Pausiere stattdessen — du behältst deinen Fortschritt bis zum {date}, danach wird dein Abo automatisch fortgesetzt und nach 3 Monaten in voller Höhe für einen neuen Zeitraum abgerechnet, es sei denn, du setzt vorher fort.",
    manageOfferPauseBtn: "Stattdessen pausieren",
    manageOfferContinueLink: "Trotzdem kündigen",
    manageOfferDismiss: "Doch nicht",
    pauseOfferLabel: "Brauchst du eine Pause?",
    pauseOfferSub: "Pausiere dein Abo für 3 Monate, statt zu kündigen — dein Fortschritt bleibt erhalten, du kannst jederzeit fortsetzen.",
    pauseOfferBtn: "Abo pausieren",
    pauseConfirmP1: "Dein Speafy Pro-Abo pausieren?",
    pauseConfirmC1: "Dein aktueller Abrechnungszeitraum läuft bis {date} weiter — du behältst alles, wofür du bereits bezahlt hast.",
    pauseConfirmC2: "Während der Pause sind neue Lektionen gesperrt (wie bei einem abgelaufenen kostenlosen Plan), aber du kannst deine vorhandenen Karteikarten weiterhin normal wiederholen.",
    pauseConfirmC3: "Die Pause dauert fest 3 Monate. Wenn du bis dahin nicht manuell fortsetzt, wird dein Abo automatisch fortgesetzt und in voller Höhe für einen neuen Zeitraum abgerechnet.",
    pauseConfirmBtn: "Pause bestätigen",
    pausing: "Wird pausiert…",
    pauseFailedGeneric: "Beim Pausieren deines Abos ist etwas schiefgelaufen. Bitte versuche es erneut oder kontaktiere den Support.",
    manageLinkLoading: "Wird geladen…",
    manageLinkFailedGeneric: "Ein Verwaltungslink konnte gerade nicht geladen werden. Bitte versuche es erneut.",
    resumeConfirmP1: "Dein Speafy Pro-Abo jetzt fortsetzen?",
    resumeConfirmC1: "Du wirst sofort in voller Höhe für einen neuen Abrechnungszeitraum belastet.",
    resumeConfirmBtn: "Ja, jetzt fortsetzen",
    resumeFailedGeneric: "Beim Fortsetzen deines Abos ist etwas schiefgelaufen. Bitte versuche es erneut oder kontaktiere den Support.",
    subscriptionLastCharge: "Letzte Abbuchung: {amount} am {date} — {status}",
    subscriptionLastChargePaid: "Bezahlt",
    subscriptionLastChargeFailed: "Fehlgeschlagen",
    tierChangePendingLabel: "Tarifwechsel geplant",
    tierChangePendingToElite: "Wechsel zu Elite am {date}",
    tierChangePendingToBasic: "Wechsel zu Pro am {date}, am Ende deines aktuellen Abrechnungszeitraums",
    tierUpgradeToEliteLink: "Auf Elite upgraden",
    tierDowngradeToBasicLink: "Zurück zu Pro wechseln",
    tierUpgradeConfirmTitle: "Auf Elite upgraden?",
    tierUpgradeConfirmSub: "Dir wird heute die anteilige Differenz berechnet, und du erhältst sofort Elites 3 Stunden Sprachgespräch mit Babi — {price}/{interval} ab jetzt.",
    tierDowngradeConfirmTitle: "Zurück zu Pro wechseln?",
    tierDowngradeConfirmSub: "Du behältst Elite bis {date}, dann wechselst du zu deinem nächsten Abrechnungstermin zu Pro — heute keine Kosten.",
    tierUpgradeConfirmBtn: "Ja, jetzt upgraden",
    tierDowngradeConfirmBtn: "Ja, zu Pro wechseln",
    tierChangeBusy: "Wird aktualisiert…",
    tierChangeFailedGeneric: "Beim Ändern deines Tarifs ist etwas schiefgelaufen. Bitte versuche es erneut oder kontaktiere den Support.",
    voiceMinutesLabel: "Sprachminuten ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Testphase",
    voiceTierAdmin: "Admin",
    voiceTierViewer: "Betrachter",
    voiceMinutesUsed: "{used} von {limit} in diesem Zyklus verwendet",
    voiceMinutesPurchasedExtra: "Zusätzlich {extra} gekauft — wird nach Aufbrauchen deiner Monatsminuten genutzt und verfällt nie",
    yourDataSection: "Deine Daten",
    marketingLabel: "Einwilligung zu Marketing-Kommunikation",
    marketingSub: "Updates, Benachrichtigungen und Sonderangebote",
    voiceConsentLabel: "Sprachchat mit Babi",
    voiceConsentSub: "Erlaube Babi, dich zu hören und laut zu antworten",
    privacyLegalSection: "Datenschutz, Bedingungen & Rechtliches",
    privacyPolicyLabel: "Datenschutzerklärung",
    privacyPolicySub: "Wie wir deine Daten erheben, nutzen und schützen",
    viewLink: "Ansehen",
    termsLabel: "Nutzungsbedingungen",
    termsSub: "Regeln und Bedingungen für deine Nutzung",
    refundLabel: "Rückerstattungsrichtlinie",
    refundSub: "Anspruchsvoraussetzungen und Vorgehen bei einer Rückerstattung",
    cookieSettingsLabel: "Cookie-Einstellungen",
    cookieSettingsSub: "Analyse- und Funktions-Cookies verwalten",
    manageLink: "Verwalten",
    privacySection: "Datenschutz & Daten",
    exportLabel: "Meine Daten exportieren",
    exportSub: "JSON-Datei mit Profil, Fortschritt und Karteikarten herunterladen",
    exportBtn: "Exportieren",
    exportDone: "✓ Heruntergeladen",
    cacheLabel: "Lokaler Cache",
    cacheSub: "Lernfortschritt und Beispielsätze werden für Geschwindigkeit in Ihrem Browser gespeichert.",
    cookieLabel: "Cookie- & Datenschutzeinstellungen",
    cookieSub: "Analyse- und Cookie-Präferenzen werden auf der Speafy-Website verwaltet",
    privacyLink: "Datenschutzrichtlinie ↗",
    aboutSection: "Über",
    aiTutorLabel: "KI-Tutor",
    aiTutorSub: "Betrieben von Claude Sonnet — Anthropic",
    algoLabel: "Gedächtnis-Algorithmus",
    algoSub: "FSRS v4.5 — Freier Spaced-Repetition-Planer",
    learningSection: "Lernen",
    placementTestLabel: "Einstufungstest",
    placementTestSubNew: "Finde mit einem kurzen Test dein Startniveau",
    placementTestSubRetake: "Zuletzt eingestuft: {level} · jederzeit wiederholbar",
    placementTestBtnNew: "Test starten",
    placementTestBtnRetake: "Test wiederholen",
    versionLabel: "Version",
    appearanceSection: "Darstellung",
    darkModeLabel: "Dunkelmodus",
    darkModeSub: "Zu einem dunklen Farbschema wechseln",
    largeTextLabel: "Großer Text",
    largeTextSub: "Schriftgröße für einfacheres Lesen erhöhen",
    babiCheckinsSection: "Babi Check-ins",
    babiDailyNudgeLabel: "Babis täglicher Anstoß",
    babiDailyNudgeSub: "Babi fragt, wie viel Zeit du hast, und schlägt dir jeden Tag einen Lernplan vor",
    babiWeeklyReportLabel: "Babis Wochenbericht",
    babiWeeklyReportSub: "Eine wöchentliche Zusammenfassung deines Fortschritts, einmal pro Woche",
    dangerSection: "Gefahrenzone",
    resetLabel: "Alle Fortschritte zurücksetzen",
    resetSub: "Löscht Ihre Serie, Karteikarten und den Lektionsverlauf. Nicht rückgängig zu machen.",
    resetBtn: "Zurücksetzen",
    resetConfirmP1: "Alle Fortschritte zurücksetzen? Folgendes wird dauerhaft gelöscht:",
    resetConfirmC1: "Alle {n} Karteikarten und ihre Gedächtnisdaten",
    resetConfirmC2: "Ihre Serie ({n} Tage) und Lernverlauf",
    resetConfirmC3: "Alle abgeschlossenen Lektions-Aufzeichnungen, in jeder Sprache, die Sie lernen",
    resetConfirmC4: "Ihr Wiederholungsfortschritt im Grammatik-Labor",
    resetConfirmP2: "Ihr Konto, Name und Spracheinstellungen bleiben erhalten.",
    resetConfirmBtn: "Ja, alles zurücksetzen",
    resetting: "Wird zurückgesetzt…",
    resetDone: "✅ Fortschritt zurückgesetzt! Sie beginnen von vorne.",
    deleteLabel: "Konto löschen",
    deleteSub: "Löscht Ihr Konto und alle Daten dauerhaft. Nicht rückgängig zu machen.",
    deleteBtn: "Konto löschen",
    deleteConfirmP1: "Ihr Speafy-Konto dauerhaft löschen? Folgendes wird sofort und unwiderruflich gelöscht:",
    deleteConfirmC1: "Ihr Profil (Name, Sprache, Ziele)",
    deleteConfirmC2: "Alle {n} Karteikarten und Gedächtnisdaten",
    deleteConfirmC3: "Ihren vollständigen Lernverlauf und Ihre Serie",
    deleteConfirmC4: "Ihr Firebase-Authentifizierungskonto",
    deleteConfirmPrompt: "Geben Sie DELETE (in Großbuchstaben) zur Bestätigung ein:",
    deleteConfirmBtn: "Mein Konto dauerhaft löschen",
    deleting: "Wird gelöscht…",
    cancelBtn: "Abbrechen",
  },
  trial: {
    daysLeftBadge: "⏱ {n} Tage verbleibend",
    expiredBadge: "Test abgelaufen · Upgrade ↑",
    pausedBadge: "⏸ Pausiert",
    proBadge: "✦ Pro-Plan",
    eliteBadge: "✦ Elite-Plan",
  },
  paywall: {
    back: "← Zurück",
    title: "Auf Speafy Pro upgraden",
    subTrialExpired: "Deine Testphase ist abgelaufen. Upgrade zum Weiterlernen.",
    subDefault: "Alle Lektionen und Lernkarten-Wiederholung freischalten.",
    features: [
      "Alle {count} Lektionen vollständig freigeschaltet",
      "Unbegrenzte Chats mit Babi, deinem KI-Tutor",
      "Intelligente FSRS-Lernkarten",
      "Fortschrittsverfolgung & Gedächtnisanalysen",
      "Native-Audio für jedes Wort",
      "Übungsdialoge",
      "Mehrsprachige Benutzeroberfläche",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Alles aus Speafy Pro",
      "Hören-&-Sprechen-Labor — geführtes Sprechtraining mit Babi",
      "3 Stunden Sprachgespräch mit Babi pro Monat",
      "Jederzeit zusätzliche Sprachminuten kaufen — 3 $/Stunde",
    ],
    billingMonthly: "Monatlich",
    billingYearly: "Jährlich",
    saveBadge: "25% sparen",
    pricePerMonth: "/Monat",
    priceBilledYearly: "jährlich abgerechnet",
    cta: "Speafy Pro starten →",
    ctaElite: "Speafy Elite starten →",
    fine: "Jederzeit kündbar · Sicherer Checkout via Paddle",
    bannerExpired: "Deine kostenlose Testphase ist abgelaufen.",
    bannerActive: "Kostenlose Testphase — noch {n} Tag{s}.",
    bannerBtn: "Upgrade ↑",
    settingsFreePlan: "Kostenloser Plan",
    pausedTitle: "Dein Abo ist pausiert",
    pausedSub: "Setze dein Abo in den Einstellungen fort, um neue Lektionen wieder freizuschalten.",
    pausedGoToSettingsBtn: "Zu den Einstellungen",
    alreadyProTitle: "Du bist bereits Pro!",
    alreadyProSub: "Dein Abo ist aktiv — du musst nicht erneut kaufen.",
    alreadyProGoHomeBtn: "Zur Startseite",
    settingsTrialRemaining: "Test — noch {n} Tag{s}",
    settingsTrialEnded: "Test abgelaufen — upgraden, um alle Lektionen freizuschalten",
    settingsFreeForever: "Mach dort weiter, wo du aufgehört hast — upgraden, um alle Lektionen freizuschalten",
    settingsUpgradeBtn: "Upgrade",
  },
  authAction: {
    verifyingTitle: "Ihre E-Mail wird verifiziert…",
    verifiedTitle: "Ihre E-Mail-Adresse ist bestätigt!",
    verifiedBody: "Alles bereit. Fahren Sie mit Speafy fort, um weiterzulernen.",
    continueBtn: "Weiter zu Speafy →",
    verifyErrorTitle: "Dieser Link ist abgelaufen",
    verifyErrorBody: "Dieser Bestätigungslink ist nicht mehr gültig. Melden Sie sich an, und wir senden Ihnen einen neuen.",
    resendBtn: "Bestätigungs-E-Mail erneut senden",
    resendSent: "Gesendet ✓",
    resendError: "Erneutes Senden fehlgeschlagen. Bitte versuchen Sie es gleich noch einmal.",
    signInBtn: "Anmelden",
    verifyingReset: "Ihr Link wird überprüft…",
    resetTitle: "Passwort zurücksetzen",
    resetBodyFor: "Wählen Sie ein neues Passwort für {email}",
    newPasswordPh: "Neues Passwort",
    confirmPasswordPh: "Neues Passwort bestätigen",
    resetSubmitBtn: "Passwort zurücksetzen",
    resettingBtn: "Wird zurückgesetzt…",
    resetSuccessTitle: "Passwort aktualisiert!",
    resetSuccessBody: "Ihr Passwort wurde geändert. Melden Sie sich mit Ihrem neuen Passwort an.",
    resetErrorTitle: "Dieser Link ist abgelaufen",
    resetErrorBody: "Dieser Link zum Zurücksetzen des Passworts ist nicht mehr gültig. Fordern Sie über den Anmeldebildschirm einen neuen an.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein.",
    genericError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    invalidTitle: "Dieser Link ist ungültig oder abgelaufen",
    invalidBody: "Der Link, dem Sie gefolgt sind, ist nicht mehr gültig. Bitte kehren Sie zu Speafy zurück und versuchen Sie es erneut.",
    backToSignIn: "Zurück zur Anmeldung",
  },

  // Teacher-partner affiliate disclosure — FINALIZED wording, do not edit/re-translate.
  // `reviewed: false` → a native speaker flips it to `true` after confirming. See strings.js.
  affiliate: {
    disclosure: {
      text: "Kurzer Hinweis: Wenn du dich über meinen Link bei Speafy anmeldest, bekomme ich eine kleine Provision – für dich kostet es nichts extra.",
      reviewed: false,
    },
    // Promo message — FINALIZED + native-verified. `{{referral_link}}` is a literal placeholder. See strings.js.
    promoTemplate: {
      text: "Hallo zusammen! Ich möchte euch eine App empfehlen, die eine tolle Ergänzung zu unserem Unterricht ist: Speafy. Sie orientiert sich genau an den Themen, die wir gemeinsam durchnehmen, und ihr könnt jederzeit mit einer KI-Gesprächspartnerin namens Babi das Sprechen üben. Der Einstieg ist kostenlos, und ich bekomme einen wöchentlichen Bericht über euren Fortschritt – so kann ich sehen, wie ihr zwischen unseren Stunden vorankommt. Meldet euch über diesen Link an, damit ihr mir als eurer Lehrkraft zugeordnet werdet: {{referral_link}}",
      reviewed: true,
    },
  },

  teacherDash: {
    link: "Lehrkraft-Dashboard",
    title: "Lehrkraft-Dashboard",
    backHome: "Zurück zur Startseite",
    studentBadge: "Deine Lehrkraft: {name}",
    intro: "Alles, was du brauchst, um deine Schülerinnen und Schüler zu Speafy zu holen und ihren Fortschritt zu verfolgen.",
    referralTitle: "Dein Empfehlungslink",
    referralBody: "Teile diesen Link mit deinen Schülerinnen und Schülern. Wer sich darüber registriert, wird dir als Lehrkraft zugeordnet.",
    copy: "Link kopieren",
    copied: "Kopiert",
    shareText: "Lern mit mir zusammen eine Sprache auf Speafy! {link}",
    shareTelegramText: "Lern mit mir zusammen eine Sprache auf Speafy!",
    shareEmailSubject: "Mach mit auf Speafy",
    shareWhatsapp: "WhatsApp",
    shareTelegram: "Telegram",
    shareEmail: "E-Mail",
    shareSms: "SMS",
    shareMore: "Mehr",
    studentsTitle: "Deine Schülerinnen und Schüler",
    studentsLoading: "Schülerinnen und Schüler werden geladen…",
    studentsError: "Deine Schülerinnen und Schüler konnten gerade nicht geladen werden.",
    retry: "Erneut versuchen",
    studentsEmpty: "Noch keine Schülerinnen und Schüler. Teile deinen Empfehlungslink – wer darüber beitritt, erscheint hier.",
    colName: "Schüler/in",
    colJoined: "Beigetreten",
    colStatus: "Abo",
    colCommission: "Verdiente Provision",
    colGrammar: "Grammatikschwerpunkt",
    statusActive: "Aktiv",
    statusTrial: "Testphase",
    statusNone: "Kein Abo",
    commissionNote: "Das hast du insgesamt mit jedem Schüler verdient. Dein für eine Auszahlung verfügbares Guthaben wird unten angezeigt.",
    commissionCapReached: "12-Monats-Zeitraum beendet",
    grammarNote: "Grammatikfehlerdaten werden nur für Schüler mit aktivem Abonnement angezeigt.",
    studentUnnamed: "Schüler/in",
    curriculumTitle: "Lehrplan-Referenz",
    curriculumBody: "Sieh dir alle Themen und Wörter an, die deine Schülerinnen und Schüler lernen – in der richtigen Reihenfolge.",
    curriculumLink: "Lehrplan-Referenz öffnen",
    profileTitle: "Dein Lehrkraft-Profil",
    profileBody: "So erscheinst du im Speafy-Lehrkräfteverzeichnis, sobald es startet.",
    profileBio: "Kurze Bio",
    profileBioPh: "Ein oder zwei Sätze über dich und wie du unterrichtest.",
    profilePhoto: "Foto",
    photoChoose: "Foto auswählen",
    photoUploading: "Wird hochgeladen…",
    photoRemove: "Entfernen",
    photoHint: "PNG oder JPG, bis zu 200 KB.",
    photoTypeErr: "Bitte wähle ein PNG- oder JPG-Bild.",
    photoSizeErr: "Dieses Bild ist über 200 KB — bitte wähle ein kleineres.",
    photoUploadErr: "Hochladen fehlgeschlagen. Bitte versuche es erneut.",
    profileLink: "Persönliche Website oder Social-Media-Link",
    profileLinkPh: "www.beispiel.de",
    profileLanguages: "Sprachen, die ich unterrichte",
    profileLanguagesHint: "Wähle die Sprachen, die du unterrichtest. Weitere werden freigeschaltet, sobald Speafy sie als Kurssprachen hinzufügt.",
    profileLanguagesSoon: "Bald verfügbar",
    save: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Gespeichert",
    urlError: "Das sieht nicht nach einer Webadresse aus. Prüfe sie oder lass das Feld leer.",
    termsStatusAccepted: "Partnerbedingungen für Lehrkräfte — Angenommen am {date}",
    termsStatusPending: "Partnerbedingungen für Lehrkräfte — Noch nicht angenommen",
    termsVersionLabel: "Version {version}",
    termsView: "Angenommene Bedingungen ansehen",
    payoutTitle: "Auszahlung",
    payoutLoading: "Dein Auszahlungsstatus wird geladen…",
    payoutError: "Wir konnten deinen Auszahlungsstatus gerade nicht laden.",
    payoutBalance: "Dein aktuelles Guthaben: {balance}",
    payoutNotEligible: "Du kannst eine Auszahlung anfordern, sobald dein Guthaben {threshold} erreicht.",
    payoutAlreadyRequested: "Auszahlung angefordert — wir melden uns bei dir.",
    requestPayoutBtn: "Auszahlung anfordern",
    payoutRequestFailed: "Beim Senden deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    payoutConfirmTitle: "Auszahlung anfordern?",
    payoutConfirmBody: "Du hast derzeit {balance} zur Anforderung verfügbar.\n\nDies startet einen manuellen Auszahlungsprozess — es wird kein Geld automatisch bewegt. Wir prüfen deine Anfrage und melden uns per E-Mail.",
    payoutConfirmBtn: "Auszahlung anfordern",
    payoutConfirmCancel: "Abbrechen",
  },

  teacherTerms: {
    screenTitle: "Partnerbedingungen für Lehrkräfte",
    contents: "Inhalt",
    lastUpdatedLabel: "Zuletzt aktualisiert",
    effectiveLabel: "Datum des Inkrafttretens",
    bannerTitle: "Aktion erforderlich",
    bannerBody: "Bitte lies und akzeptiere die Partnerbedingungen für Lehrkräfte, um Partner zu bleiben.",
    bannerCta: "Lesen und akzeptieren",
    acceptedOn: "Du hast diese Bedingungen am {date} akzeptiert.",
    acceptedVersion: "Akzeptierte Version: {version}",
    accepting: "Deine Zustimmung wird gespeichert…",
    acceptError: "Wir konnten deine Zustimmung gerade nicht speichern. Bitte versuche es erneut.",
    draftNotice: "Diese Bedingungen sind noch nicht endgültig. Du kannst sie annehmen, sobald das Datum des Inkrafttretens feststeht.",
  },
};

export default de;
